import { apiRequest } from "../http";
import { IResponse } from "../../types/response.type";

interface AppTicketData {
	id: number;
	task_id: string;
	buyer_id: number;
	bundle_id: string;
	attribution_service_name: string;
	status: string;
	stage: string;
	created_at: string;
	last_updated_at: string;
}

interface GetAllTicketsSuccessData {
	tickets: AppTicketData[];
	count: number;
}

interface TicketActionSuccessData {
	success: boolean;
	ticket_id: number;
	action: "accept" | "reject" | string;
	message: string;
}

export type IGetAllAppTicketsResponse = IResponse<GetAllTicketsSuccessData>;
export type IAcceptAppTicketResponse = IResponse<TicketActionSuccessData>;
export type IRejectAppTicketResponse = IResponse<TicketActionSuccessData>;

export async function getAllAppTickets(): Promise<IGetAllAppTicketsResponse> {
	return await apiRequest<GetAllTicketsSuccessData>({
		path: "/api/app-ticket/tickets/all",
		method: "GET",
	});
}

export async function acceptAppTicket(
	ticketId: number,
): Promise<IAcceptAppTicketResponse> {
	return await apiRequest<TicketActionSuccessData>({
		path: `/api/app-ticket/tickets/${ticketId}/accept`,
		method: "POST",
	});
}

export async function rejectAppTicket(
	ticketId: number,
): Promise<IRejectAppTicketResponse> {
	return await apiRequest<TicketActionSuccessData>({
		path: `/api/app-ticket/tickets/${ticketId}/reject`,
		method: "POST",
	});
}
